import {Route, Router, Routes } from 'react-router-dom';
import './App.css';
import Loading from './Pages/Loading';
import Game from './Pages/Game';

function App() {
  return (
    // <Router>
    <Routes>
      <Route path="/" element={<Loading />} />
      <Route path='/Game' element={<Game />} />
    </Routes>
    // </Router>
  )
}

export default App;
